import { useTranslation } from "react-i18next";
import { KitProductModel } from "../../../Api/Models/product.model";
import { LongArrowRightIcon } from "../../../Components/Icons/LongArrowRightIcon";
import { PlusIcon } from "../../../Components/Icons/PlusIcon";
import { MinusIcon } from "../../../Components/Icons/MinusIcon";
import DotBreadcrumbs from "../../../Components/DotBreadcrumbs";

interface RemainingProductsProps {
  kitProducts: KitProductModel[];
  setItemChecked(productId: number): void;
  skipRemainingProducts: CallableFunction;
  back: CallableFunction;
  currentStep: number;
  totalSteps: number;
}

const RemainingProducts: React.FunctionComponent<RemainingProductsProps> = ({
  kitProducts,
  setItemChecked,
  skipRemainingProducts,
  back,
  currentStep,
  totalSteps
}) => {
  const { t } = useTranslation();

  return (
      <div>

        {kitProducts.map((product) => (
            <>
              <div key={product.id}
                   className={"product-list-card mb-4 " + (product.stockEnough && product.checked ? " marked" : "") + (!product.stockEnough ? " disabled" : "")}>
                <div className="flex items-center gap-2">
                  <div className="relative">
                    <div className="product-list-card__image">
                      <img src={product.image} alt={product.name}/>
                    </div>

                    {product.checked && (
                        <div className="product-list-card__marked-tick">
                          <svg width="16" height="16" viewBox="0 0 18 18" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <rect x="1" y="1" width="16" height="16" rx="8" fill="#ffffff"/>
                            <rect x="1" y="1" width="16" height="16" rx="8" stroke="#ffffff"/>
                            <path d="M6.5 8.9248L8.30239 11L11.5 7" stroke="#3F4067" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                    )}
                  </div>

                  <div className="w-full">
                    <div className="product-list-card__title">
                      {product.quantity > 1 ? `${product.quantity} x ` : null}
                      {product.name}
                    </div>
                  </div>

                  <div className="flex gap-2 items-center">
                    {product.stockEnough ? (
                        <button
                            type="button"
                            className={"check-rounded" + (product.checked ? " marked" : "")}
                            onClick={() => setItemChecked(product.id)}
                        >
                          {product.checked ? <MinusIcon/> : <PlusIcon/>}
                        </button>
                    ) : (
                        /*<TimeIcon />*/
                        <div className="product-list-card__out-of-stock">
                          {t("Out of stock")}
                        </div>
                    )}
                  </div>
                </div>
              </div>
            </>
        ))}

        <div className="mt-8 mb-8">
          <DotBreadcrumbs currentStep={totalSteps-1} totalSteps={totalSteps}/>
        </div>

        <div className="flex gap-4 pb-4">
          <div className="flex-1">
            <div
                className="button button--light w-full"
                onClick={() => back()}
            >
              {t('Back')}
            </div>
          </div>
          <div className="flex-1">
            <div
                className="button w-full"
                onClick={() => skipRemainingProducts()}
            >
              {t('Next')} <LongArrowRightIcon/>
            </div>
          </div>
        </div>

      </div>
  );
};

export default RemainingProducts;
